import { render, staticRenderFns } from "./ContestForm.vue?vue&type=template&id=1145061b&"
import script from "./ContestForm.ts?vue&type=script&lang=ts&"
export * from "./ContestForm.ts?vue&type=script&lang=ts&"
import style0 from "./ContestForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports